import { render, staticRenderFns } from "./editQuote.vue?vue&type=template&id=4d3b8b43&"
import script from "./editQuote.vue?vue&type=script&lang=js&"
export * from "./editQuote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports